'use client';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@ps/ui/atoms/alert-dialog';

interface Props {
  /** The join failure to surface; `null` keeps the dialog closed. */
  error: Error | null;
  /** Dismiss handler — clears the error so the dialog closes. */
  onClose: () => void;
}

/**
 * Error alert shown when joining a community channel fails — mirrors
 * PopshopRN's `alert({ title: 'Error', … })`. A single acknowledge button;
 * dismissing clears the error on the {@link useJoinChannel} hook.
 */
export function ChannelJoinErrorDialog({ error, onClose }: Props) {
  return (
    <AlertDialog
      open={error != null}
      onOpenChange={open => {
        if (!open) onClose();
      }}
    >
      {/* No `.dark` pin and no `dark:` pair: the theme lives on <html>, and a
          portal to <body> is still a descendant of it, so these roles already
          resolve against the creator's choice. */}
      <AlertDialogContent className="border-line bg-surface-1">
        <AlertDialogHeader>
          <AlertDialogTitle>Couldn&rsquo;t join this channel</AlertDialogTitle>
          <AlertDialogDescription>
            {error?.message ??
              'Something went wrong while joining. Please try again later.'}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            onClick={onClose}
            className="bg-brand text-content-on-brand hover:bg-brand-hover-hover"
          >
            OK
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
